export function normalizeEmployeeGender(gender) {
  const g = String(gender || "").trim().toLowerCase();
  if (g === "female" || g === "f" || g === "girl" || g === "girls") {
    return "female";
  }
  if (g === "male" || g === "m" || g === "boy" || g === "boys") {
    return "male";
  }
  return null;
}

export function isMaternityLeaveType(leaveType) {
  const name = String(leaveType?.name || leaveType?.leaveTypeName || "").toLowerCase();
  const code = String(leaveType?.code || "").toLowerCase();
  return (
    name.includes("maternity") ||
    code === "ml" ||
    code.includes("maternity") ||
    (code.includes("mat") && !code.includes("menstrual"))
  );
}

export function isMenstrualLeaveType(leaveType) {
  const name = String(leaveType?.name || leaveType?.leaveTypeName || "").toLowerCase();
  const code = String(leaveType?.code || "").toLowerCase();
  return (
    name.includes("menstrual") ||
    name.includes("menstruation") ||
    code === "mn" ||
    code.includes("menstrual") ||
    code.includes("menst")
  );
}

export function isFemaleOnlyLeaveType(leaveType) {
  return isMaternityLeaveType(leaveType) || isMenstrualLeaveType(leaveType);
}

export function isPaternityLeaveType(leaveType) {
  const name = String(leaveType?.name || leaveType?.leaveTypeName || "").toLowerCase();
  const code = String(leaveType?.code || "").toLowerCase();
  return name.includes("paternity") || code.includes("paternity");
}

export function isLeaveTypeApplicableToGender(leaveType, employeeGender) {
  const gender = normalizeEmployeeGender(employeeGender);
  const applicability = String(
    leaveType?.genderApplicability || "all"
  ).toLowerCase();

  if (applicability === "female" && gender !== "female") return false;
  if (applicability === "male" && gender !== "male") return false;

  if (gender === "male" && isFemaleOnlyLeaveType(leaveType)) return false;
  if (gender === "female" && isPaternityLeaveType(leaveType)) return false;

  return true;
}

export function filterLeaveTypesByGender(leaveTypes, employeeGender) {
  return (leaveTypes || []).filter((leaveType) =>
    isLeaveTypeApplicableToGender(leaveType, employeeGender)
  );
}

export function genderMismatchReason(leaveType, employeeGender) {
  const code = leaveType?.code || leaveType?.name || "leave type";
  const gender = normalizeEmployeeGender(employeeGender) || "unknown";
  return `${code} is not applicable for ${gender} employees`;
}
